import { EMPTY_OBJECT } from '../../../../../constants/common'
import { FILE_SCOPE_EMAIL } from '../../../../../constants/file'
import { stopPropagation } from '../../../../../utils/events'
import { FileAttachedItemsModal } from '../../../../File'
import { getEmailMessageFiles } from '../../../Email.api'
import { EmailProfileMessageAttachedFilesModalCounter } from '../../EmailProfileMessageAttachedFilesModalCounter'

import {
  getApiProps,
  getDataPagination,
  getItemsFromResponse,
} from './useEmailProfileMessageAttachedFiles.utils'

export function useEmailProfileMessageAttachedFiles({
  filePreviewProps: {
    scope: filePreviewScope = FILE_SCOPE_EMAIL,
    ...filePreviewProps
  } = EMPTY_OBJECT,
  getFilesApi,
  uuid,
  onCloseModal,
  onSetModal,
}) {
  function handleClickFileTag(event) {
    stopPropagation(event)

    onSetModal(
      <FileAttachedItemsModal
        readonly
        ButtonCancel={false}
        ButtonRemove={false}
        Counter={EmailProfileMessageAttachedFilesModalCounter}
        filePreviewProps={{ ...filePreviewProps, scope: filePreviewScope }}
        getApiProps={getApiProps}
        getData={getFilesApi ?? getEmailMessageFiles}
        getDataPagination={getDataPagination}
        getItemsFromResponse={getItemsFromResponse}
        objectId={uuid}
        onClose={onCloseModal}
      />
    )
  }

  return {
    handleClickFileTag,
  }
}
